import { GetProp, TableProps } from "antd";
import { utilityService } from "shared/services";
import { IProjectInCloseoutStage } from "projects/models";
import { Link } from "react-router-dom";
import { IOrganization } from "organizations/models";
import { buildOrganizationSectionPath } from "shared/utils/paths";

type ColumnsType<T extends object> = GetProp<TableProps<T>, "columns">;

export const getProjectsInCloseoutStageColumns = (organization: IOrganization | undefined): ColumnsType<IProjectInCloseoutStage> =>
  [
    {
      title: "",
      dataIndex: "id",
      width: 100,
      fixed: "left",
      render: (value, record, index) => index + 1,
    },
    {
      title: "Project",
      dataIndex: "projectName",
      render: (value, record, index) => (
        <Link to={buildOrganizationSectionPath(organization, `projects/${record.id}`)}>
          {utilityService.truncateField(value)}
        </Link>
      ),
    },
    {
      title: "Latest Project Note",
      dataIndex: "latestProjectNote",
      render: (value, record, index) => (
        <div
          dangerouslySetInnerHTML={{
            __html: utilityService.truncateHtml(value?.content as string),
          }}
        />
      ),
    },
    {
      title: "Project Installation Completed Date",
      dataIndex: "projectInstallationCompletedDate",
      render: (value, record, index) => utilityService.dateFormatter(value),
    },
    {
      title: "Completion Document Sent To Customer",
      dataIndex: "completionDocumentSentToCustomer",
      render: (value, record, index) => utilityService.dateFormatter(value),
    },
    {
      title: "Total Project Value",
      dataIndex: "totalProjectValue",
      render: (value, record, index) =>
        `$${utilityService.statisticsFormatter(value)}`,
    },
  ];
